<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">

      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="偵測期間">
              <a-month-picker :default-value="moment(queryParam.yyyymm, 'YYYY年MM月')" v-model="queryParam.yyyymm"
                format="YYYY年MM月" valueFormat="YYYYMM" style="width: 100%" />
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="BG">
              <a-select v-model="queryParam.bg_name" :options="bgNameOptions">
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="製銷管研">
              <a-select v-model="queryParam.pl_account" :options="plAccountOptions">
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="科目類別">
              <a-select v-model="queryParam.account_item3" :options="accountItem3Options">
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="YoY增/減">
              <a-select v-model="queryParam.sorting" :options="sortingOptions">
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="搜索">
              <a-input v-model="queryParam.keyword">
              </a-input>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{
                language['common.searchButton']
              }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{
                language['common.resetButton']
              }}</a-button>
              <!-- <a @click="handleToggleSearch"
                 style="margin-left: 8px">
                {{ toggleSearchStatus ? language['common.foldButton'] : language['common.unfoldButton'] }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
              </a> -->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div>
      <a-table ref="table" size="middle" bordered rowKey="id" class="j-table-force-nowrap" :scroll="{ x: 2000 }"
        :columns="columns" :dataSource="dataSource" :pagination="false" :loading="loading">

        <template slot="chart">
          <a-icon type="line-chart" />
        </template>

        <template slot="analysis" slot-scope="text,record">
          <a-icon type="zoom-in" @click="handlerAnalysis(record)" />
        </template>
      </a-table>
    </div>

    <yoy-modal ref="modalForm" @ok="modalFormOk"></yoy-modal>
  </a-card>
</template>

<script>
import Vue from 'vue'
import { getAction, postAction } from '@/api/manage'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import YoyModal from './modules/YoyModal.vue'
import moment from 'moment'
import 'moment/locale/zh-cn';

export default {
  name: 'YoyList',
  mixins: [JeecgListMixin],
  components: {
    YoyModal,
  },
  data() {
    return {
      url: {
        getTokenUrl: '/epi/expense/getToken',
        list: '/epi/expense/getTop20Yoy'
      },
      queryParam: {
        accessToken: Vue.ls.get("accessToken"),
        yyyymm: moment(new Date()).format('YYYYMM'),
      },
      bgNameOptions: [],
      plAccountOptions: [],
      accountItem3Options: [],
      sortingOptions: [
        { label: '增加', value: 'increase' },
        { label: '减少', value: 'decrease' }
      ],
      dataList: [],
      disableMixinCreated: true
    }
  },

  computed: {
    columns() {
      if (this.language) {
        return [
          {
            title: '篩選排名(YoY差異)',
            dataIndex: '',
            key: 'rowIndex',
            width: 160,
            align: 'center',
            customRender: function (t, r, index) {
              return parseInt(index) + 1
            },
          },
          {
            title: 'BG Code',
            align: 'center',
            width: 200,
            dataIndex: 'bg_code',
            ellipsis: true,
          },
          {
            title: 'BG名稱',
            align: 'center',
            width: 200,
            ellipsis: true,
            dataIndex: 'bg_name',
          },
          {
            title: 'SBG Code',
            align: 'center',
            width: 120,
            dataIndex: 'sbg_code',
          },
          {
            title: 'SBG名稱',
            align: 'center',
            width: 140,
            ellipsis: true,
            dataIndex: 'sbg_name',
          },

          {
            title: '會科編碼',
            align: 'center',
            width: 150,
            ellipsis: true,
            dataIndex: 'fsi',
          },
          {
            title: '會科名稱',
            dataIndex: 'fsi_name',
            width: 150,
            ellipsis: true,
          },
          {
            title: '當月費用',
            dataIndex: 'amount_after_writeoff',
            width: 200,
          },
          {
            title: 'YoY費用差異',
            dataIndex: 'year_diff',
            ellipsis: true,
            width: 100,
          },
          {
            title: 'YoY差異%',
            align: 'center',
            width: 120,
            ellipsis: true,
            dataIndex: 'year_diff_percent',
          },
          {
            title: 'AI綜合分數總排名',
            align: 'center',
            width: 170,
            dataIndex: 'suspicious_value_weighted_normalize_ranking',
          },

          {
            title: '當月異常樣態類型(12中分類)',
            ellipsis: true,
            width: 200,
            align: 'center',
            dataIndex: 'group_external',
          },
          {
            title: '偵測走勢圖',
            align: 'center',
            ellipsis: true,
            width: 150,
            scopedSlots: { customRender: 'chart' },
          },
          {
            title: '分析',
            align: 'center',
            ellipsis: true,
            width: 120,
            scopedSlots: { customRender: 'analysis' },
          },
          // {
          //   title: '回饋',
          //   align: 'center',
          //   width: 180,

          // },
          // {
          //   title: this.language['common.action'],
          //   dataIndex: 'action',
          //   align: 'center',
          //   fixed: 'right',
          //   width: 147,
          //   scopedSlots: { customRender: 'action' },
          // },
        ]
      }
    },
  },
  created() {
    this.getToken()
  },
  methods: {
    moment,
    getToken() {
      postAction(this.url.getTokenUrl).then((res) => {
        if(res.success) {
          this.$message.success('登录成功')
          Vue.ls.set('accessToken', res.result, 7 * 24 * 60 * 60 * 1000)

          this.searchQuery()
        }
      })
    },
    init() {

      this.bgNameOptions = this.dataList.map((item, index, arr) => {
        return item.bg_name
      }).filter(function (item, index, self) {
        return self.indexOf(item) == index;
      }).map((item, index, arr) => {
        let c = { label: item, value: item }
        return c
      })


      this.plAccountOptions = this.dataList.map((item, index, arr) => {
        return item.pl_account
      }).filter(function (item, index, self) {
        return self.indexOf(item) == index;
      }).map((item, index, arr) => {
        let c = { label: item, value: item }
        return c
      })
      this.plAccountOptions.push( {label: '銷管研', value: '銷管研'} ) //排除制造


      this.accountItem3Options = this.dataList.map((item, index, arr) => {
        return item.account_item3
      }).filter(function (item, index, self) {
        return self.indexOf(item) == index;
      }).map((item, index, arr) => {
        let c = { label: item, value: item }
        return c
      })
    },
    
    searchQuery() {

      if (this.queryParam.bg_name != undefined && this.queryParam.pl_account != undefined && this.queryParam.account_item3 != undefined) {
        if (this.queryParam.pl_account === '銷管研') {
          this.dataSource = this.dataList.filter(item => item.bg_name === this.queryParam.bg_name && item.pl_account != '製造費用' && item.account_item3 === this.queryParam.account_item3)
        } else {
          this.dataSource = this.dataList.filter(item => item.bg_name === this.queryParam.bg_name && item.pl_account === this.queryParam.pl_account
            && item.account_item3 === this.queryParam.account_item3)
        }

      } else if (this.queryParam.bg_name != undefined && this.queryParam.pl_account != undefined) {
        if (this.queryParam.pl_account === '銷管研') {
          this.dataSource = this.dataList.filter(item => item.bg_name === this.queryParam.bg_name && item.pl_account != '製造費用')
        } else {

          this.dataSource = this.dataList.filter(item => item.pl_account === this.queryParam.pl_account && item.bg_name === this.queryParam.bg_name)
        }
      } else if (this.queryParam.bg_name != undefined && this.queryParam.account_item3 != undefined) {

        this.dataSource = this.dataList.filter(item => item.account_item3 === this.queryParam.account_item3 && item.bg_name === this.queryParam.bg_name)
      } else if (this.queryParam.pl_account != undefined && this.queryParam.account_item3 != undefined) {
        if (this.queryParam.pl_account === '銷管研') {
          this.dataSource = this.dataList.filter(item => item.account_item3 === this.queryParam.account_item3 && item.pl_account != '製造費用')
        } else {
          this.dataSource = this.dataList.filter(item => item.account_item3 === this.queryParam.account_item3 && item.pl_account === this.queryParam.pl_account)
        }

      } else if (this.queryParam.bg_name != undefined) {

        this.dataSource = this.dataList.filter(item => item.bg_name === this.queryParam.bg_name)

      } else if (this.queryParam.pl_account != undefined) {
        if (this.queryParam.pl_account === '銷管研') {
          this.dataSource = this.dataList.filter(item => item.pl_account != '製造費用')
        } else {
          this.dataSource = this.dataList.filter(item => item.pl_account === this.queryParam.pl_account)
        }


      } else if (this.queryParam.account_item3 != undefined) {

        this.dataSource = this.dataList.filter(item => item.account_item3 === this.queryParam.account_item3)
      } else if (this.queryParam.keyword != undefined) {
        let bg_code_list = this.dataList.filter(item => item.bg_code === this.queryParam.keyword)
        let bg_name_list = this.dataList.filter(item => item.bg_name === this.queryParam.keyword)
        let sbg_code_list = this.dataList.filter(item => item.sbg_code === this.queryParam.keyword)
        let sbg_name_list = this.dataList.filter(item => item.sbg_name === this.queryParam.keyword)
        let fsi_list = this.dataList.filter(item => item.fsi === this.queryParam.keyword)
        let fsi_name_list = this.dataList.filter(item => item.fsi_name === this.queryParam.keyword)

        if (bg_code_list.length > 0) {
          this.dataSource = bg_code_list;
        } else if (bg_name_list.length > 0) {
          this.dataSource = bg_name_list;
        } else if (sbg_code_list.length > 0) {
          this.dataSource = sbg_code_list;
        } else if (sbg_name_list.length > 0) {
          this.dataSource = sbg_name_list;
        } else if (fsi_list.length > 0) {
          this.dataSource = fsi_list;
        } else if (fsi_name_list.length > 0) {
          this.dataSource = fsi_name_list;
        } else {
          this.dataSource = []
        }
      } else {
        getAction(this.url.list, this.queryParam).then((res) => {
          if (res.success) {
            this.dataList = res.result
            this.dataSource = this.dataList;

            this.init()
          }
        })
      }
    },
    handlerAnalysis(record) {
      record.yyyymm = this.queryParam.yyyymm
      this.$refs.modalForm.show(record);
      this.$refs.modalForm.title = '';
      this.$refs.modalForm.disableSubmit = false;
    },
  }
}
</script>